import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "gtr-status-card-head" }
const _hoisted_2 = { class: "card-title gtr-status-card-title" }
const _hoisted_3 = { class: "text-light fw-bold text-center gtr-status-card-title-row" }
const _hoisted_4 = { class: "gtr-card-background d-flex flex-column position-relative h-100" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "fas fa-user-circle gtr-status-avatar-icon"
}
const _hoisted_7 = { class: "active-subscription card-body d-flex overflow-hidden position-relative" }
const _hoisted_8 = { class: "table table-sm table-borderless mb-0" }
const _hoisted_9 = { class: "small" }
const _hoisted_10 = { class: "fs-6" }
const _hoisted_11 = { class: "text-end text-nowrap fw-bold" }
const _hoisted_12 = { class: "text-end text-nowrap" }
const _hoisted_13 = { class: "text-end text-nowrap" }
const _hoisted_14 = { class: "text-end text-nowrap fw-bold" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  colspan: "2",
  class: "text-end text-nowrap"
}
const _hoisted_17 = {
  class: "d-flex position-relative",
  style: {"z-index":"9"}
}
const _hoisted_18 = { class: "card-footer position-relative text-center" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "text-nowrap" }
const _hoisted_22 = {
  key: 0,
  class: "inactive-label fw-bold"
}
const _hoisted_23 = {
  key: 0,
  class: "card-action d-flex flex-column position-relative justify-content-center mx-4 pt-2 pb-3 border"
}
const _hoisted_24 = { class: "small text-center mb-2" }
const _hoisted_25 = { class: "" }
const _hoisted_26 = { class: "monthly-price text-nowrap" }
const _hoisted_27 = { class: "text-nowrap" }
const _hoisted_28 = { class: "text-center" }
const _hoisted_29 = ["disabled"]
const _hoisted_30 = {
  key: 0,
  class: "fas fa-spinner fa-spin ms-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_package_icon = _resolveComponent("package-icon")!

  return (_ctx.isLoaded)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass([_ctx.levelClass, _ctx.cardType])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["d-flex flex-column gtr-status-card w-100 position-relative", { 'inactive-subscription': !_ctx.isActive }])
        }, [
          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "background-border" }, null, -1)),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("span", null, _toDisplayString(_ctx.SubscriptionDisplayName), 1)
              ])
            ]),
            (_ctx.IconProduct)
              ? (_openBlock(), _createBlock(_component_package_icon, {
                  key: 0,
                  product: _ctx.IconProduct,
                  "extra-class": "gtr-status-card-mark"
                }, null, 8, ["product"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_4, [
            (_ctx.getUserPicture)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "gtr-status-avatar gtr-avatar-bg",
                  src: _ctx.getUserPicture,
                  alt: "Foto de perfil"
                }, null, 8, _hoisted_5))
              : (_openBlock(), _createElementBlock("i", _hoisted_6)),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", null, [
                _createElementVNode("table", _hoisted_8, [
                  _createElementVNode("tbody", _hoisted_9, [
                    _createElementVNode("tr", _hoisted_10, [
                      _cache[3] || (_cache[3] = _createElementVNode("td", { class: "fw-bold" }, "Usuario:", -1)),
                      _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.getUsernamePK), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[4] || (_cache[4] = _createElementVNode("th", { class: "fw-bold" }, "Inicio:", -1)),
                      _createElementVNode("td", _hoisted_12, _toDisplayString(_ctx.UserStatus.startDate?.toLocaleString()), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[5] || (_cache[5] = _createElementVNode("th", { class: "fw-bold text-nowrap" }, "Último Pago:", -1)),
                      _createElementVNode("td", _hoisted_13, _toDisplayString(_ctx.UserStatus.lastPayDate?.toLocaleString()), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[6] || (_cache[6] = _createElementVNode("th", { class: "fw-bold text-nowrap" }, "Vencimiento:", -1)),
                      _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.UserStatus.endDate?.toLocaleString()), 1)
                    ]),
                    (_ctx.manualDateUpdate)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [
                          _createElementVNode("td", _hoisted_16, [
                            _createElementVNode("div", _hoisted_17, [
                              _withDirectives(_createElementVNode("input", {
                                type: "date",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.editedEndDate) = $event)),
                                class: "form-control form-control-sm"
                              }, null, 512), [
                                [_vModelText, _ctx.editedEndDate]
                              ]),
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-sm ms-2 btn-primary",
                                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.updateEndDate && _ctx.updateEndDate(...args)))
                              }, [...(_cache[7] || (_cache[7] = [
                                _createElementVNode("i", { class: "fas fa-save me-2" }, null, -1),
                                _createTextVNode("Actualizar ", -1)
                              ]))])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", null, [
                (_ctx.isActive)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_19, "Vence en: "))
                  : (_openBlock(), _createElementBlock("span", _hoisted_20, "Venció hace: ")),
                _createElementVNode("span", _hoisted_21, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["badge rounded-pill fs-6", _ctx.daysLeftClass])
                  }, _toDisplayString(Math.abs(_ctx.DaysLeft)), 3),
                  _cache[8] || (_cache[8] = _createTextVNode(" ", -1)),
                  _createElementVNode("span", null, _toDisplayString(_ctx.ExpirationDurationUnitLocalized), 1)
                ])
              ])
            ])
          ]),
          (!_ctx.isActive)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [...(_cache[9] || (_cache[9] = [
                _createElementVNode("span", { class: "badge bg-danger fs-5" }, [
                  _createElementVNode("span", { class: "" }, "INACTIVA"),
                  _createElementVNode("i", {
                    class: "fa fa-times-circle ms-1",
                    "aria-hidden": "true"
                  })
                ], -1)
              ]))]))
            : _createCommentVNode("", true)
        ], 2),
        (!_ctx.isOffline && _ctx.CanRenewSubscription)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _cache[11] || (_cache[11] = _createElementVNode("div", { class: "period-label text-nowrap d-inline-block" }, "Renovar por: ", -1)),
                _createElementVNode("span", _hoisted_25, [
                  _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.SubscriptionConfig?.renewalCost || _ctx.SubscriptionConfig.cost) + " " + _toDisplayString(_ctx.SubscriptionConfig.currency), 1),
                  _createElementVNode("span", _hoisted_27, " / " + _toDisplayString(_ctx.SubscriptionConfig.duration) + " " + _toDisplayString(_ctx.SubscriptionDurationUnitLocalized), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("button", {
                  class: "btn btn-lg btn-danger gtr-renew-btn",
                  type: "button",
                  disabled: _ctx.isQuoting,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.subscriptionQuote()))
                }, [
                  _cache[12] || (_cache[12] = _createTextVNode("Renovar ", -1)),
                  (_ctx.isQuoting)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_30))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_29)
              ])
            ]))
          : _createCommentVNode("", true)
      ], 2))
    : _createCommentVNode("", true)
}